import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle, CardSection } from 'components/Card';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import Message from 'components/Message';
import Button from 'components/Button';
import { bem } from 'helpers/class-name';
import messages from '../Campaigns.messages';
import './Modals.scss';

const { block, element } = bem('campaigns-modal');

const CampaignEndModal = props => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { name, onModalConfirm, onClose } = props;

  function handleOnConfirm() {
    setIsSubmitting(true);
    onModalConfirm();
  }

  return (
    <Card className={block()} flush>
      <CardSection>
        <div className="flex">
          <Isvg className="mr-s" src={ICONS.infoYellow} />
          <Message as={CardTitle} className={element('card-title')} message={messages.modals.endNowTitle} />
        </div>
        <Message message={messages.modals.endNowDescription} values={{ flag: !!name, name: <strong>{name}</strong> }} />
      </CardSection>
      <div className={element('buttons')}>
        <Message as={Button} className="mr-s" styled="tertiary" message={messages.form.btnCancel} onClick={onClose} />
        <Message as={Button} message={messages.form.btnConfirm} onClick={handleOnConfirm} waiting={isSubmitting} />
      </div>
    </Card>
  );
};

CampaignEndModal.propTypes = {
  name: PropTypes.string,
  onModalConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

export default CampaignEndModal;
